module.exports = __webpack_public_path__ + "3b472a011c149d4e3e20899165f9d836.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanslightitalic.woff2
// module id = 690
// module chunks = 57